import { render } from "./Passport.vue?vue&type=template&id=b1c16cca"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__